
import moment from "moment";
import PageDetailHeader from '@/components/core/PageDetailHeader';
import locationModal from '@/components/modals/locationModal.vue';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import ReviewCard2 from '@/components/ReviewSection/ReviewCard2'
import loaderComponent from '@/components/loaderComponent'
import RestaurantCard from '@/components/RestaurantCard'
import CheckoutModal from '@/components/modals/CheckoutModal';
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import FaqCardPost from '@/components/FaqCardPost';

// import googleAd from '@/components/gAdUnitCode'
export default {
  layout: 'detailsPage',
  scrollToTop: true,
  components: {
      PageDetailHeader,
      locationModal,
      VueSlickCarousel,
      ReviewCard2,
      loaderComponent,
      RestaurantCard,
      CoolLightBox,
      CheckoutModal,
      FaqCardPost
  },
  head() {
      return {
          title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
          meta: [{
              hid: 'description',
              name: 'description',
              content: this.metaDesc()
          },
          {
              hid: 'keywords',
              name: 'keywords',
              content: this.metaKeywords()
          },
          {
              hid: 'image',
              property: 'image',
              content: this.metaImage()
          },
          {
              hid: 'og:title',
              property: 'og:title',
              content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
          },
          {
              hid: 'og:image',
              property: 'og:image',
              content: this.metaImage()
          },
          {
            hid: 'og:image:secure_url',
            property: 'og:image:secure_url',
            content: this.metaImage()
          },
          {
              hid: 'og:description',
              property: 'og:description',
              content: this.metaDesc()
          },
          {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App'
          },
          {
              hid: 'twitter:description',
              property: 'twitter:description',
              content: this.metaDesc()
          }
          ],
      }
  },
  data() {
      return {
          activitySlug: null,
          listings: null,
          relatedActivities: null,
          relatedPlaces: null,
          reviews: null,
          loading: true,
          offerLoading: true,
          listingLoading: true,
          touristDestSchema: [],
          seoData: null,
          faqSchemaItems: null,


          //new
          selectedSec: 'about',
          index: null,
          menuIndex: null,
          offerLoading: true,
          offerDataForModal: null,
          token: null,
          offerCode: null,
          toBeAddedToCart: null,
          addToCartLoading: false,
          redeemOfferLoading: false,
          redeemOfferSuccess: false,
          redeemOfferErr: null,
          selectedOffer: -1,
      }
  },
  jsonld() {
      if (!this.listings) {
          return null;
      }
      let structure = {
        "@context": "http://schema.org"
      } 
        let schemaData = [
            {
                "@type": "ImageObject",
                "@id": this.metaImage(),
                "url": this.metaImage(),
                "contentUrl": this.metaImage(),
                "caption": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title : 'Restaurant in Goa',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
                }, 
              {
                  "@type": "Restaurant",
                  "name": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title + " in Goa | Goa App" : 'Goa App',
                  "url": `https://goa.app/restaurant/${this.listings && this.listings.post && this.listings.post.slug ? this.listings.post.slug : 'Goa-app'}`,
                  "image": this.metaImage(),
                  "servesCuisine": "Goan",
                  "priceRange": "₹ ₹ 1000 for two approx (approx.). ",
                  "telephone": "+919309138956",
                  "address": {
                      "@type": "PostalAddress",
                      "streetAddress": this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.address : '',
                      "addressLocality": "Goa",
                      "addressRegion": "Goa",
                      "postalCode": null,
                      "addressCountry": "IN"
                  },
                  "geo": {
                      "@type": "GeoCoordinates",
                      "latitude": this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.latitude : '',
                      "longitude": this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.longitude : ''
                  },
                  "acceptsReservations": false,
                  "openingHoursSpecification": [
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Monday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Tuesday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Wednesday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Thursday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Friday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Saturday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      },
                      {
                          "@type": "OpeningHoursSpecification",
                          "dayOfWeek": [
                              "Sunday"
                          ],
                          "opens": "11:00:00",
                          "closes": "23:00:00"
                      }
                  ],
                  "currenciesAccepted": "INR",
                  "paymentAccepted": [
                      "Cash",
                      "Credit Cards",
                      "Wallet"
                  ],
                  "aggregateRating": {
                      "@type": "AggregateRating",
                      "ratingCount": "250",
                      "ratingValue": this.listings && this.listings.post && this.listings.post.rating ? this.listings.post.rating.averageRating : '5',
                      "reviewCount": this.listings && this.listings.post && this.listings.post.views ? String(this.listings.post.views.count).slice(0, 2) : '5'
                  },
              }
          ];

       //For FAQ schema
    let faqSchema = null;
    if (this.faqSchemaItems) {
      faqSchema = {
        "@type": "FAQPage",
        mainEntity: this.faqSchemaItems,
      };
      schemaData.push(faqSchema);
    }
    let ds = {
      "@graph": schemaData,
    };
    return { ...structure, ...ds };
  },
  async validate({
      params,
      store
  }) {
      // await operations
      if (params.slug != (null || "")) {
          this.activitySlug = params.slug;
          return true // if the params are valid
      } else {
          return false // will stop Nuxt.js to render the route and display the error page
      }
  },
  async asyncData({ error, route, $axios }) {
    try {
      let data = await $axios.get('/api/posts/seo/getSEOContent/' + route.params.slug)
    } catch {
      error({ statusCode: 404, message: 'Post not found' })
    }
  },
  created() {
      this.activitySlug = this.$route.params.slug;
      this.$fetch();
  },
  destroyed() {
      if (document.getElementById('placereviewClose'))
          document.getElementById('placereviewClose').click();
  },
  async fetch() {
      this.seoData = await fetch(this.$config.fetchUrl + '/api/posts/seo/getSEOContent/' + this.activitySlug)
          .then(res => res.json()).catch(error => {
              this.$router.push({
                  path: '/'
              })
              console.error("There was an error!", error); return false;
          });
  },
  mounted() {
      //this.getAllData();
      this.getPageData();
  },
  methods: {
      metaDesc() {
          if (this.seoData && this.seoData.description) {
              return this.seoData.description
          } else {
              return 'best restaurants in goa, restaurants in goa, famous restaurants in goa, top restaurants in goa, veg restaurants in goa, top 10 restaurants in goa, beach restaurants in goa, pure veg restaurants in goa, vegan restaurants in goa, best veg restaurants in goa'
          }
      },
      metaKeywords() {
          if (this.seoData && this.seoData.keywords) {
              return this.seoData.keywords;
          } else {
              return 'best restaurants in goa, restaurants in goa, famous restaurants in goa, top restaurants in goa, veg restaurants in goa, top 10 restaurants in goa, beach restaurants in goa, pure veg restaurants in goa, vegan restaurants in goa, best veg restaurants in goa'
          }
      },
      metaImage() {
          if (this.seoData && this.seoData.image) {
              return this.seoData.image;
          } else {
              return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
          }
      },


      async getPageData() {
          //Get the list of post data
          if (localStorage.getItem("authToken") != (null || undefined)) {
              this.token = localStorage.getItem("authToken");
              const headers = {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': this.token,
              }
              // AXIOS api call to add SIGNIN api
              this.$axios
                  .get('/api/posts/app/getRestaurantBySlugUser/' + this.activitySlug, {
                      headers: headers
                  })
                  .then(response => {
                      // New flow
                      this.$nextTick(() => {
                          this.populateData(response.data);
                      })
                  })
          } else {
              this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getRestaurantBySlug/' + this.activitySlug)
                  .then(res => res.text()).catch(error => {
                      console.error("There was an error!", error); return false;
                  });
              this.$nextTick(() => {
                  this.populateData(this.listings);
              })
          }
      },

      populateData(data) {
          this.listings = this.getCryptKey(data);
          //For FAQ schema start
        if(this.listings && this.listings.post && this.listings.post.faq  && this.listings.post.faq.length > 0){
                this.faqSchemaItems = this.listings.post.faq.map((item, index) => ({
                    '@type': 'Question',
                    position: index + 1,
                    "name":item.title,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text":  item.description
                    },
                }));
          }
          //For FAQ schema end
          this.$nextTick(() => {
              this.loading = false;
              this.offerLoading = false;
          })
      },

      getTermsArr(terms) {
          let arr = terms.split("\n")
          arr = arr.filter(item => item);
          return arr
      },


      async getAllData() {
          //Get the list of post data
          this.listings = await fetch(this.$config.fetchUrl + '/api/posts/app/getPostBySlug/' + this.activitySlug)
              .then(res => res.text()).catch(error => {
                  this.$router.push({
                      path: '/'
                  })
                  console.error("There was an error!", error); return false;
              });
          this.listings = this.getCryptKey(this.listings);


          this.$nextTick(() => {
              this.loading = false;
              this.offerLoading = false;
          })
          this.relatedPlaces = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyPlaces/' + this.activitySlug)
              .then(res => res.text())
          this.relatedPlaces = this.getCryptKey(this.relatedPlaces);
          this.relatedActivities = await fetch(this.$config.fetchUrl + '/api/posts/app/getNearbyActivities/' + this
              .activitySlug)
              .then(res => res.text())
          this.relatedActivities = this.getCryptKey(this.relatedActivities);
          this.touristDestSchema = this.relatedActivities.map(v => ({
              "@type": ["TouristAttraction"],
              "name": v.post && v.post.title ? v.post.title : 'Goa App',
              "image": v.post && v.post.gallery ? v.post.gallery : [],
              "sameAs": v.post && v.post.slug ? `https://goa.app/activities/${v.post.slug}` : 'Goa App'
          }));
          this.reviews = await fetch(this.$config.fetchUrl + '/api/posts/app/getReviews/' + this.activitySlug)
              .then(res => res.text())
          this.reviews = this.getCryptKey(this.reviews);
      },


      // Login Functionalities
      userCreated() {
          this.offerLoading = true;
          this.getPageData();
          if (this.toBeAddedToCart)
              this.addOfferToCart(this.toBeAddedToCart)
      },
      unlockOfferClick(addItemToCart) {
          if (localStorage.getItem("authToken") != (null || undefined)) {
              this.token = localStorage.getItem("authToken");
              this.addOfferToCart(addItemToCart);
          } else {
              this.toBeAddedToCart = addItemToCart;
              this.$bvModal.show('checkout')
              // this.$router.push({
              //   path: '/register/'
              // })
              return
          }
      },
      redeemOfferCall(item) {
          this.redeemOfferErr = null;
          this.redeemOfferSuccess = false;
          if (localStorage.getItem("authToken") != (null || undefined)) {
              this.redeemOfferLoading = true
              // Create formData instance to pass the data to the API
              var formData = new URLSearchParams();
              formData.append("offer", item._id);
              formData.append("pin", this.offerCode);
              // Add header for the API
              const headers = {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': this.token
              }
              // AXIOS api call to add categories api
              this.$axios
                  .post(`/api/offers/redeemOffer`, formData, {
                      headers: headers
                  })
                  .then(response => {
                      this.toBeAddedToCart = null;
                      this.offerCode = null;
                      let value = this.getCryptKey(response.data);
                      if (value.success) {
                          this.getPageData();
                          this.redeemOfferSuccess = true;
                      } else {
                          this.redeemOfferErr = value.message
                      }
                  })
                  .catch(error => {
                      localStorage.clear();
                      this.$router.push({
                          path: "/accounts/login"
                      });
                  })
                  .finally(() => {
                      this.redeemOfferLoading = false;
                  });
          } else {
              this.toBeAddedToCart = null;
              this.$bvModal.show('checkout')
          }
      },
      addOfferToCart(item) {
          this.addToCartLoading = true
          // Create formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append("offer", item._id);
          // Add header for the API
          const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': this.token
          }
          // AXIOS api call to add categories api
          this.$axios
              .post(`/api/offerCarts/app/v2/addToOfferCart`, formData, {
                  headers: headers
              })
              .then(response => {
                  let value = this.getCryptKey(response.data);
                  this.$router.push({
                      path: "/offers"
                  });
                  this.addToCartLoading = false;
              })
              .catch(error => {
                  this.addToCartLoading = false;
                  localStorage.clear();
                  this.$router.push({
                      path: "/accounts/login"
                  });
              })
              .finally(() => {
                  this.addToCartLoading = false;
              });
      },

      // To add a fallback placeholder image if not rendereds from API
      setFallbackImageUrl(event) {
          event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
      },

      getLatLongForMap() {
          if (this.listings.post && this.listings.post.location && this.listings.post.location.latitude && this.listings
              .post.location.longitude) {
              return this.listings.post.location.latitude + "," + this.listings.post.location.longitude
          }
          return ""
      },
      getGuidelineArr(guideline) {
          let arr = guideline.split("\n")
          arr = arr.filter(item => item);
          return arr
      },

      // Store filters in Localstorage
      scrollHere(item) {
          this.$nextTick(() => {
              this.scrollToJsOffers(item)
          })
      },
  }
}
